import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { useTrpc } from './_next/useTrpc';
export function useGetHistoricalOrders() {
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var orders = ref({});
  var loading = ref(false);
  var error = ref(null);
  var load = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            loading.value = true;
            _context.prev = 1;
            _context.next = 4;
            return client.historicalOrder.getHistoricalOrders.query();
          case 4:
            orders.value = _context.sent;
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            error.value = _context.t0;
          case 10:
            _context.prev = 10;
            loading.value = false;
            return _context.finish(10);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7, 10, 13]]);
    }));
    return function load() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    orders: orders,
    loading: loading,
    error: error,
    load: load
  };
}